import { render, staticRenderFns } from "./Scroller.vue?vue&type=template&id=531642e8"
import script from "./Scroller.vue?vue&type=script&lang=js"
export * from "./Scroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports